import { StorageKeysEnum } from '@/enums/storageKeys.enum';

import { useLocalStorage } from '@/hooks/useLocalStorage';

export const useJwt = () => {
  const {
    value: jwt,
    setItem: setJwt,
    removeItem: removeJwt,
  } = useLocalStorage<string>(StorageKeysEnum.jwt);
  const {
    value: refreshToken,
    setItem: setRefreshToken,
    removeItem: removeRefreshToken,
  } = useLocalStorage<string>(StorageKeysEnum.refreshToken);

  return {
    jwt,
    setJwt,
    removeJwt,
    refreshToken,
    setRefreshToken,
    removeRefreshToken,
  };
};
